import PropTypes from "prop-types";
import { CustomContainer } from "../../../DependencyHelper";
import { getValueLabel } from "../../../../../utils/helperServices";
import formStyles from "../CreditCheckDetails.module.scss";

const DeliveryDetailsInfo = ({ data, stateTypesOptions }) => {
  const displayAddress = () => {
    let finalAdd = "";

    if (data) {
      let neUnit =
        data.address?.unitNo !== "" && data.address?.complexName !== ""
          ? data.address.unitNo + " " + data.address.complexName + ", "
          : data.address?.unitNo !== ""
          ? data.address.unitNo + ", "
          : data.address?.complexName !== ""
          ? data.address.complexName + ", "
          : "";
      let neStreet =
        data.address?.streetNo !== "" && data.address?.streetName !== ""
          ? data.address.streetNo + " " + data.address.streetName + ", "
          : data.address?.streetNo !== ""
          ? data.address.streetNo + ", "
          : data.address?.streetName !== ""
          ? data.address.streetName + ", "
          : "";
      let neSuburb =
        data.address?.suburb !== "" ? data.address.suburb + ", " : "";
      let neTown = data.address?.town !== "" ? data.address.town + ", " : "";
      let neProvince =
        data.address?.province !== ""
          ? getValueLabel(data.address.province, stateTypesOptions) + ", "
          : "";
      let nePostal =
        data.address?.postalCode !== "" ? data.address.postalCode : "";

      finalAdd = neUnit + neStreet + neSuburb + neTown + neProvince + nePostal;
    }

    return finalAdd;
  };

  return (
    <CustomContainer className={`${formStyles["form-details-container"]}`}>
      <CustomContainer className="row">
        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-lg-6 col-sm-12`}
        >
          <label>Delivery type:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-lg-6 col-sm-12`}>
          <span>Delivery via {data?.receiveType}</span>
        </CustomContainer>

        <CustomContainer
          className={`${formStyles["pb-1"]} ${formStyles["pb-6"]} col-lg-6 col-sm-12`}
        >
          <label>Delivery address:</label>
        </CustomContainer>
        <CustomContainer className={`${formStyles["pb-1"]} col-lg-6 col-sm-12`}>
          <span>{displayAddress()}</span>
        </CustomContainer>

        <CustomContainer className={`${formStyles["pb-6"]} col-lg-6 col-sm-12`}>
          <label>Contact number:</label>
        </CustomContainer>
        <CustomContainer className={`col-lg-6 col-sm-12`}>
          <span>{data?.cellNumber}</span>
        </CustomContainer>
      </CustomContainer>
    </CustomContainer>
  );
};

DeliveryDetailsInfo.propTypes = {
  data: PropTypes.object,
  stateTypesOptions: PropTypes.array,
};

DeliveryDetailsInfo.defaultProps = {
  stateTypesOptions: [],
};

export default DeliveryDetailsInfo;